import { inject, Injectable } from '@angular/core';
import type { FieldTemplateType } from '@dash/randy/modules/crud/fields/field-template/classes/field-template.model';
import {
  FIELD_ROOT_ELEMENT_PERMISSIONS,
  getCollectionItemPermissions,
  getTemplateCapabilityPermissions,
  type TemplateCapability,
} from '../classes/application-permissions';
import { CognitoService } from './cognito.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class ApplicationPermissionService {
  private readonly cognitoService = inject(CognitoService);
  private readonly currentPermissions = toSignal(this.cognitoService.permissions$, { initialValue: {} });

  hasAny(permissions: readonly string[]): boolean {
    this.currentPermissions();
    return permissions.some(permission => this.cognitoService.getPermissions(permission));
  }

  hasTemplateCapability(type: FieldTemplateType, capability: TemplateCapability): boolean {
    return this.hasAny(getTemplateCapabilityPermissions(type, capability));
  }

  canViewCollectionItems(type: FieldTemplateType | null | undefined): boolean {
    return !!type && this.hasAny(getCollectionItemPermissions(type, false));
  }

  canManageCollectionItems(type: FieldTemplateType | null | undefined): boolean {
    return !!type && this.hasAny(getCollectionItemPermissions(type, true));
  }

  canReadElements(): boolean {
    return this.hasAny([FIELD_ROOT_ELEMENT_PERMISSIONS.read, FIELD_ROOT_ELEMENT_PERMISSIONS.write]);
  }

  canWriteElements(): boolean {
    return this.hasAny([FIELD_ROOT_ELEMENT_PERMISSIONS.write]);
  }
}
